export default "/fonts/Muli-BoldItalic.ttf?e5a04cee0fa3fe50696533dde4ef1778";